import { Box } from '@mui/material';
import { Loading } from 'framework/ui/mui-builder';
import { contentSlotSx, getFilterBarSlotSx } from './styles';

export interface ViewSlotsProps {
  filterBar?: React.ReactElement | null;
  contentLayout?: React.ReactElement;
  loading?: boolean;
}

const ViewSlots = ({ filterBar, contentLayout, loading }: ViewSlotsProps) => (
  <>
    {filterBar && <Box sx={getFilterBarSlotSx(loading)}>{filterBar}</Box>}
    <Box sx={contentSlotSx}>
      {contentLayout}
      {loading && <Loading hasBackground />}
    </Box>
  </>
);

export default ViewSlots;
